// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rugby/XDL/types";

import ToastPresentationPropsDefault, {
    toasterProps as toasterPropsDefault,
} from "@insite/mobius/Toast/presentationProps";
import get from "@insite/mobius/utilities/get";
import Attention from "@rugby/XDL/Icons/Attention";
import CheckmarkRound from "@rugby/XDL/Icons/CheckmarkRound";
import CloseRound from "@rugby/XDL/Icons/CloseRound";
import Info from "@rugby/XDL/Icons/Info";
import colors from "@rugby/XDL/PreStyle/colors";
import { css } from "styled-components";

const iconWrapperWidth = 40;
const backgroundColor = get(colors, "common.toast.light");
const backgroundIconColor = get(colors, "common.toast.dark");
const textColor = get(colors, "common.white");

export default {
    defaultProps: {
        ...ToastPresentationPropsDefault,
        cssOverrides: {
            toast: css`
                border: 1px solid ${backgroundColor};
                border-radius: 4px;
                background: ${backgroundColor};
                min-height: 40px;
                width: 560px;
            `,
            toastBody: css`
                margin: 0 40px 0 0 !important;
                padding-right: 40px;
                align-items: initial;
                align-items: center;

                > span:not(:first-child) {
                    color: ${textColor};
                }

                span[data-test-selector="toastBody"] {
                    padding: 12px 0;
                }
            `,
        },
        iconProps: {
            size: 20,
            css: css`
                background: ${backgroundIconColor};

                border: 1px solid ${backgroundIconColor};
                border-radius: 3px 0 0 3px;

                margin-right: 13px;
                height: 100%;
                width: ${iconWrapperWidth}px;

                flex: 0 0 40px;
                justify-content: center;
                align-items: flex-start;

                padding: ${iconWrapperWidth / 2 - 8}px 0;
                svg {
                    z-index: 10;
                }

                // to make background "dark color" take full height in the long message
                &:after {
                    content: " ";
                    position: absolute;

                    width: ${iconWrapperWidth}px;
                    height: 100%;

                    background: ${backgroundIconColor};
                    top: 0;
                    bottom: 0;
                    left: 0;
                    border: 0;
                }
            `,
        },
        bodyTypographyProps: {
            color: "common.white",
        },
        closeButtonProps: {
            color: "transparent",
        },
        closeButtonIconProps: {
            color: "common.white",
            size: 14,
        },
        iconSrcByMessage: {
            success: CheckmarkRound,
            danger: CloseRound,
            warning: Attention,
            info: Info,
        },
    },
    toasterProps: { toasterPropsDefault },
} as xBaseTheme["toast"];
